export default function getAvatar(url: string | string) {
  if (!url) return null;
  return url.replace('portrait/', '');
}
